import { mapActions, mapGetters, mapMutations } from 'vuex';
import { RECORD_CLICK, HANDLE_CLICK, SETUP_INIT_DATA } from '../../stores/opoCourse/actions/_types';
import {
  TOGGLE_MONTH,
  TOGGLE_MONTH_SESSIONS,
  TOGGLE_SOLD_OUT_SESSIONS,
} from '../../stores/opoCourse/mutations/_types';

export default {
  computed: {
    ...mapGetters('opo-course', ['location', 'sessions', 'noSessions']),
  },
  created() {
    const { sessionsByMonth } = this;

    this[SETUP_INIT_DATA]({
      sessionsByMonth,
    });
  },
  methods: {
    ...mapActions('opo-course', [RECORD_CLICK, HANDLE_CLICK, SETUP_INIT_DATA]),
    ...mapMutations('opo-course', [TOGGLE_MONTH, TOGGLE_MONTH_SESSIONS, TOGGLE_SOLD_OUT_SESSIONS]),
  },
};
